var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeylogger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_36",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 137.5H102C80.737 137.5 63.5 154.737 63.5 176V335.527C63.5 356.79 80.737 374.027 102 374.027H410C431.263 374.027 448.5 356.79 448.5 335.527V176C448.5 154.737 431.263 137.5 410 137.5Z",
    fill: "#606060",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.828 310.852H160.172C156.582 310.852 153.672 313.762 153.672 317.352V335.66C153.672 339.25 156.582 342.16 160.172 342.16H351.828C355.418 342.16 358.328 339.25 358.328 335.66V317.352C358.328 313.762 355.418 310.852 351.828 310.852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.945 169.367H118.195C114.605 169.367 111.695 172.277 111.695 175.867V199.617C111.695 203.207 114.605 206.117 118.195 206.117H141.945C145.535 206.117 148.445 203.207 148.445 199.617V175.867C148.445 172.277 145.535 169.367 141.945 169.367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.906 169.367H181.156C177.566 169.367 174.656 172.277 174.656 175.867V199.617C174.656 203.207 177.566 206.117 181.156 206.117H204.906C208.496 206.117 211.406 203.207 211.406 199.617V175.867C211.406 172.277 208.496 169.367 204.906 169.367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.844 169.367H307.094C303.504 169.367 300.594 172.277 300.594 175.867V199.617C300.594 203.207 303.504 206.117 307.094 206.117H330.844C334.434 206.117 337.344 203.207 337.344 199.617V175.867C337.344 172.277 334.434 169.367 330.844 169.367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.875 169.367H244.125C240.535 169.367 237.625 172.277 237.625 175.867V199.617C237.625 203.207 240.535 206.117 244.125 206.117H267.875C271.465 206.117 274.375 203.207 274.375 199.617V175.867C274.375 172.277 271.465 169.367 267.875 169.367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.805 169.367H370.055C366.465 169.367 363.555 172.277 363.555 175.867V199.617C363.555 203.207 366.465 206.117 370.055 206.117H393.805C397.395 206.117 400.305 203.207 400.305 199.617V175.867C400.305 172.277 397.395 169.367 393.805 169.367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.844 236.227H101.094C97.5038 236.227 94.5938 239.137 94.5938 242.727V266.477C94.5938 270.066 97.5038 272.977 101.094 272.977H124.844C128.434 272.977 131.344 270.066 131.344 266.477V242.727C131.344 239.137 128.434 236.227 124.844 236.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.359 236.227H172.609C169.02 236.227 166.109 239.137 166.109 242.727V266.477C166.109 270.066 169.02 272.977 172.609 272.977H196.359C199.949 272.977 202.859 270.066 202.859 266.477V242.727C202.859 239.137 199.949 236.227 196.359 236.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.875 236.227H244.125C240.535 236.227 237.625 239.137 237.625 242.727V266.477C237.625 270.066 240.535 272.977 244.125 272.977H267.875C271.465 272.977 274.375 270.066 274.375 266.477V242.727C274.375 239.137 271.465 236.227 267.875 236.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.391 236.227H315.641C312.051 236.227 309.141 239.137 309.141 242.727V266.477C309.141 270.066 312.051 272.977 315.641 272.977H339.391C342.98 272.977 345.891 270.066 345.891 266.477V242.727C345.891 239.137 342.98 236.227 339.391 236.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.906 236.227H387.156C383.566 236.227 380.656 239.137 380.656 242.727V266.477C380.656 270.066 383.566 272.977 387.156 272.977H410.906C414.496 272.977 417.406 270.066 417.406 266.477V242.727C417.406 239.137 414.496 236.227 410.906 236.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeylogger);
export default __webpack_public_path__ + "static/media/keylogger.7eb10b6f340da4cdbe374942bac740d5.svg";
export { ForwardRef as ReactComponent };